import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, Content, Dropdown, DropdownItem, ExportButton, ExportWrapper, HeaderContainer, Subtitle, Title } from './MainContainer.styles';

import Sidebar from '../../Sidebar/Sidebar';
import Footer from '../../Footer/Footer';

import { selectedLocale } from '../../../store/slices/common/slice';
import { useDispatch, useSelector } from 'react-redux';
import MobileHeader from '../MobileHeader/MobileHeader';
import { AnimatePresence } from 'framer-motion';
import { FaFileExcel, FaFilePdf } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { generateInventoryFile } from '../../../store/slices/inventory/asyncThunks';

const MainContainer = ({ children, hideHeader, pageTitle, exportButton, totalInventoryValue }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const locale = useSelector(selectedLocale);
  const ar = locale === 'ar';

  const handleGenerateFile = type => {
    dispatch(generateInventoryFile(type))
      .unwrap()
      .then(res => {
        const mimeType = type === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

        const blob = new Blob([res.data], { type: mimeType });
        const fileURL = URL.createObjectURL(blob);

        if (type === 'pdf') {
          window.open(fileURL);
        } else {
          const link = document.createElement('a');
          link.href = fileURL;
          link.setAttribute('download', `inventory.${type}`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(fileURL);
        }

        setOpen(false);
      })
      .catch(err => {
        console.error(err.message);
      });
  };

  return (
    <Container>
      <Sidebar ar={ar} />
      <MobileHeader />

      <Content>
        {!hideHeader && (
          <HeaderContainer>
            <div style={{ flexDirection: 'column', display: 'flex', gap: 10 }}>
              <Title>{t(pageTitle)}</Title>
              {!!totalInventoryValue && (
                <Subtitle>
                  {t('total-inventory-value')}: {totalInventoryValue} SR
                </Subtitle>
              )}
            </div>
            {exportButton && (
              <ExportWrapper>
                <ExportButton onClick={() => setOpen(!open)}>
                  {t('export')}
                  <MdKeyboardArrowDown style={{ rotate: open ? '180deg' : '0deg', transition: 'all 0.3s ease-in-out' }} />
                </ExportButton>

                <AnimatePresence>
                  {open && (
                    <Dropdown
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.2 }}>
                      <DropdownItem onClick={() => handleGenerateFile('xlsx')}>
                        <FaFileExcel /> XLS
                      </DropdownItem>
                      <DropdownItem onClick={() => handleGenerateFile('pdf')}>
                        <FaFilePdf /> PDF
                      </DropdownItem>
                    </Dropdown>
                  )}
                </AnimatePresence>
              </ExportWrapper>
            )}
          </HeaderContainer>
        )}
        {children}
      </Content>
      {/* <Footer ar={ar} /> */}
    </Container>
  );
};

export default MainContainer;
